import { ENGAGEMENTS_TASKS } from 'crm-events-data';
import { getTaskTimelineCardErrorMsg } from './TaskTimelineCardErrorMsg';
import { makeLoadableCard } from 'crm-events-components/internal/helpers/makeLoadableCard';
export const taskConfig = {
  component: makeLoadableCard(() => import( /* webpackChunkName: "compact-card-task" */'crm-timeline-tasks/components/CompactTask')),
  minkowskiEventNameForFiltering: ENGAGEMENTS_TASKS,
  getTimelineCardErrorMsg: getTaskTimelineCardErrorMsg
};